 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"main": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + "8e39f9fe" + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01ebc60a":1,"chunk-07e11ae9":1,"chunk-0c26701c":1,"chunk-10972090":1,"chunk-111eecdb":1,"chunk-15fdd033":1,"chunk-1e1d95e4":1,"chunk-286b80de":1,"chunk-2b29a9fa":1,"chunk-5f1f9b7c":1,"chunk-63ef52ce":1,"chunk-4db17e5d":1,"chunk-8e3445a2":1,"chunk-a035e1d6":1,"chunk-d606c6d8":1,"chunk-b6b26a58":1,"chunk-3480f89c":1,"chunk-1b2fdea2":1,"chunk-1d89a919":1,"chunk-211d8a16":1,"chunk-246589f7":1,"chunk-27be3d14":1,"chunk-29b036e5":1,"chunk-2a0c2d74":1,"chunk-2cee69ca":1,"chunk-3a2e81f4":1,"chunk-0d138c00":1,"chunk-7b6e96c5":1,"chunk-7ca731a0":1,"chunk-4a9d9727":1,"chunk-639e61e5":1,"chunk-9829c17e":1,"chunk-a4f9fd72":1,"chunk-01bb4e96":1,"chunk-02feacc0":1,"chunk-0533fc5b":1,"chunk-057db017":1,"chunk-36ec6b8c":1,"chunk-68f5fe48":1,"chunk-69b3226e":1,"chunk-a0db8940":1,"chunk-0997b7cf":1,"chunk-763a9f73":1,"chunk-e069b6ec":1,"chunk-d9064988":1,"chunk-58ced3db":1,"chunk-7c317734":1,"chunk-2f1343d0":1,"chunk-30ad0238":1,"chunk-32191dee":1,"chunk-325f9a20":1,"chunk-34b3d670":1,"chunk-36c274d2":1,"chunk-3b874514":1,"chunk-3cdd8c70":1,"chunk-4473f851":1,"chunk-4d6cb057":1,"chunk-4da41681":1,"chunk-5895518b":1,"chunk-589bb27d":1,"chunk-5bf810b9":1,"chunk-63e3bc09":1,"chunk-0a660b98":1,"chunk-72b35d06":1,"chunk-6854203a":1,"chunk-6878a0d9":1,"chunk-6e901f56":1,"chunk-6f5009d0":1,"chunk-77fdf9f9":1,"chunk-7c1763e7":1,"chunk-7c2562c5":1,"chunk-88e0f60c":1,"chunk-99f2ef1c":1,"chunk-a039dc0e":1,"chunk-a4bac2e4":1,"chunk-b8073f18":1,"chunk-4822965f":1,"chunk-dc8d1ee8":1,"chunk-e1cf28d8":1,"chunk-ea626486":1,"chunk-f232cb2c":1,"chunk-f24e6706":1,"chunk-f4d9f02a":1,"chunk-f9161a2e":1,"chunk-faae92ca":1,"chunk-5ece2c58":1,"chunk-fc586296":1,"chunk-4b570f40":1,"chunk-1ae10db2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-01ebc60a":"5dcf8740","chunk-07e11ae9":"28c24f36","chunk-0c26701c":"07187c5e","chunk-0c7b2c68":"31d6cfe0","chunk-10972090":"a37d274b","chunk-111eecdb":"0886a3ec","chunk-15fdd033":"bd637e2d","chunk-16f712c9":"31d6cfe0","chunk-1e1d95e4":"6752105c","chunk-286b80de":"ff4e1bbe","chunk-2b29a9fa":"de989f6a","chunk-5f1f9b7c":"a2eb72b3","chunk-63ef52ce":"a5b956d0","chunk-4db17e5d":"0e62e291","chunk-8e3445a2":"5360cede","chunk-a035e1d6":"8825216f","chunk-d606c6d8":"2fba676f","chunk-fc1dd094":"31d6cfe0","chunk-2d0d4051":"31d6cfe0","chunk-b6b26a58":"06377243","chunk-3480f89c":"b8da32d5","chunk-1b2fdea2":"2e8340e5","chunk-1d89a919":"4dec8ecb","chunk-211d8a16":"33fed185","chunk-246589f7":"228a108f","chunk-27be3d14":"0d2683c4","chunk-28904146":"31d6cfe0","chunk-29b036e5":"6a809503","chunk-2a0c2d74":"e202d755","chunk-2cee69ca":"10cfd6b9","chunk-2d0b2b47":"31d6cfe0","chunk-3a2e81f4":"1a52cdaa","chunk-2d0b2ee5":"31d6cfe0","chunk-2d0c510d":"31d6cfe0","chunk-0d138c00":"d805f96f","chunk-7b6e96c5":"dadb46cb","chunk-7ca731a0":"5942be12","chunk-4a9d9727":"44d04022","chunk-639e61e5":"367adc16","chunk-9829c17e":"5ca18b76","chunk-a4f9fd72":"72a39fec","chunk-01bb4e96":"adb85d17","chunk-02feacc0":"32e69846","chunk-0533fc5b":"dd415f2f","chunk-057db017":"2d4a6743","chunk-36ec6b8c":"5d7fa889","chunk-68f5fe48":"2a68ade9","chunk-69b3226e":"0276f4fc","chunk-a0db8940":"11f32428","chunk-0997b7cf":"245af583","chunk-763a9f73":"876303f2","chunk-e069b6ec":"0439cd21","chunk-d9064988":"1fdd0901","chunk-58ced3db":"ea684d97","chunk-2d0c8206":"31d6cfe0","chunk-7c317734":"40d0c29b","chunk-2d0e9702":"31d6cfe0","chunk-2d0f028e":"31d6cfe0","chunk-2d20e788":"31d6cfe0","chunk-2d2160f1":"31d6cfe0","chunk-2d229afb":"31d6cfe0","chunk-2f1343d0":"5e28219d","chunk-30ad0238":"9f606c55","chunk-32191dee":"414a2024","chunk-325f9a20":"8d3c9cfb","chunk-34b3d670":"a81bfca5","chunk-36c274d2":"3197986e","chunk-3b874514":"c1919065","chunk-3cdd8c70":"fdff0fbc","chunk-4463fdfe":"31d6cfe0","chunk-4473f851":"c978fb4a","chunk-4d6cb057":"33fed185","chunk-4da41681":"2c099a52","chunk-5895518b":"32b4a5cd","chunk-589bb27d":"d13c34be","chunk-5bf810b9":"80b4c4ce","chunk-63e3bc09":"30a38f75","chunk-0a660b98":"81bf7003","chunk-72b35d06":"dcdd7b72","chunk-6854203a":"aa0703ae","chunk-6878a0d9":"14972a5b","chunk-6e901f56":"0886a3ec","chunk-6f5009d0":"bcebd232","chunk-74c48a5b":"31d6cfe0","chunk-77fdf9f9":"34c5d3fe","chunk-7c1763e7":"c978fb4a","chunk-7c2562c5":"0886a3ec","chunk-88e0f60c":"50881934","chunk-99f2ef1c":"995c8cd8","chunk-a039dc0e":"8f37a07e","chunk-a4bac2e4":"6ffc6807","chunk-b8073f18":"a2aad21b","chunk-4822965f":"d1ac2c69","chunk-dc8d1ee8":"048aad50","chunk-e1cf28d8":"7020d0f2","chunk-ea626486":"5edfee1f","chunk-2d0ae9a7":"31d6cfe0","chunk-f232cb2c":"6fe789e9","chunk-f24e6706":"fac7ca08","chunk-f4d9f02a":"96b24a5f","chunk-f9161a2e":"7bd47d96","chunk-faae92ca":"92d4ab9e","chunk-5ece2c58":"4353d8bd","chunk-fc586296":"e05219fe","chunk-4b570f40":"05f78818","chunk-1ae10db2":"30706fd1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//cdnstatic.gamekee.com/wiki/4.0/pc/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push(["a949","chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
